import React from 'react';
import PropTypes from 'prop-types';
import { Row, Divider, Typography } from 'antd';
import { Licenses } from '@clinician-profile/components';
import { CandidateOfferListItem } from '@applicant-flow/components';
import { Card, Gap } from '@common/components';

const { Title } = Typography;

export default function CandidateProfileTab({ worksProfile }) {
  const sortedOffers = worksProfile?.sortedOffers || [];

  return (
    <Row className="candidate-row">
      <section className="candidate-title-section">
        <Title level={4} className="section-title">
          Summary
        </Title>
        <p className="section-body">{worksProfile.profileSummary}</p>

        <Divider type="horizontal" style={{ marginTop: '1rem' }} />
      </section>
      <section className="candidate-sidebar-section">
        {!!sortedOffers?.length && (
          <Card title="Offers">
            <Gap vertical size="md">
              {sortedOffers?.map((offer) => (
                <CandidateOfferListItem key={offer.id} offer={offer} />
              ))}
            </Gap>
          </Card>
        )}
        <br />
        <Licenses licenses={worksProfile.licenses} />
      </section>
      <style jsx>{`
        :global(.candidate-row) {
          flex-wrap: nowrap;
        }
        .candidate-title-section {
          flex-grow: 1;
          margin-right: 1rem;
          overflow: auto;
        }
        .candidate-sidebar-section {
          flex-shrink: 0;
        }
        .section-body {
          overflow-wrap: break-word;
        }
        .profile-header {
          margin-bottom: 2rem;
        }
        section :global(.profile-title) {
          margin: 0 16px;
        }
        .profile-titles {
          font-size: 18px;
        }
        .profile-contact {
          line-height: 2;
          margin-top: 0.5rem;
          margin-left: 38px;
        }
      `}</style>
    </Row>
  );
}

CandidateProfileTab.propTypes = {
  worksProfile: PropTypes.shape({
    profileSummary: PropTypes.string,
    worksSubmittalPackets: PropTypes.arrayOf(PropTypes.object),
    licenses: PropTypes.arrayOf(PropTypes.object),
    staffingRequestApplications: PropTypes.arrayOf(PropTypes.object),
    sortedOffers: PropTypes.arrayOf(PropTypes.object),
  }),
};
